import { AbstractControl } from '@angular/forms';

export const forceValueValidator = (value: any) => (ac: AbstractControl) => {
  if (ac.value === value) return null;
  return {
    forceValue: `Value should be ${value}`,
  };
};
